import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPaytmComponent } from './simple-icons-paytm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPaytmComponent ],
    exports:      [ SimpleIconsPaytmComponent ],
    bootstrap:    []
})
export class SimpleIconsPaytmModule {}
